import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { AccessViewBaseComponent, slideDownAnimation } from '../access-view-base/access-view-base.component'
import { AccessState } from 'src/app/services/access.service'

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'aws-account-access-view',
  templateUrl: './account-access-view.component.html',
  styleUrls: ['./account-access-view.component.scss'],
  standalone: false,
  animations: [slideDownAnimation],
})
export class AwsAccountAccessViewComponent extends AccessViewBaseComponent implements OnChanges {
  @Input() stackName: string
  @Input() templateUrl: string
  @Input() awsAccountId: string
  @Input() managedByStackSet: boolean = false

  constructor(uiService: UiService) {
    super(uiService)
  }

  // Override ngOnChanges: Only auto-collapse when truly successfully connected
  // (not when migration from StackSets is needed)
  override ngOnChanges(changes: SimpleChanges): void {
    if (changes['state'] && this.state === AccessState.SUCCESS && !this.managedByStackSet) {
      this.expanded = false
    }
  }

  // Override: Don't show as "successfully connected" if access is via StackSets
  // because user needs to deploy CloudFormation to switch
  override get successfullyConnected(): boolean {
    return this.state === AccessState.SUCCESS && !this.managedByStackSet
  }

  // New getter: Access works but is via StackSets (needs CloudFormation deployment)
  get needsCloudFormationMigration(): boolean {
    return this.state === AccessState.SUCCESS && this.managedByStackSet
  }

  // Show migration body during testing if we were in migration state
  get showMigrationDuringTest(): boolean {
    return this.testing && this.managedByStackSet
  }

  get templateName(): string {
    const url = this.templateUrl
    if (!url) return 'Loading templates...'

    const filename = url.slice(url.lastIndexOf('/') + 1)
    const queryIndex = filename.indexOf('?')
    return queryIndex !== -1 ? filename.slice(0, queryIndex) : filename
  }
}
